import { render, staticRenderFns } from "./navSetting.vue?vue&type=template&id=2de16f48&scoped=true"
import script from "./navSetting.vue?vue&type=script&lang=js"
export * from "./navSetting.vue?vue&type=script&lang=js"
import style0 from "./navSetting.vue?vue&type=style&index=0&id=2de16f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de16f48",
  null
  
)

export default component.exports